<template lang="pug">
  #authenticate
    .loginpage
      .container
        .col-md-4.col-xs-8.login-portion
          .login-form.panel.row-inlineblock
            .panel-heading
              h2.panel-title パスワードをお忘れの方
            .panel-body
              p 登録されているメールアドレスを入力してください。パスワード再設定用のメールを送信します。
              .form-group
                label.control-label(for='name') グループID
                .input-group
                  span.input-group-addon
                    span.fa.fa-user.fa-fw
                  input#name.form-control(type='text' v-model='groupId' placeholder='グループIDを入力してください')
              .form-group
                label.control-label(for='email') メールアドレス
                .input-group
                  span.input-group-addon
                    span.fa.fa-envelope.fa-fw
                  input#email.form-control(type='text' v-model='mail' placeholder='メールアドレスを入力してください')
              .form-group
                .alert.alert-danger(v-show='error_message' v-html='error_message')
                .alert.alert-success(v-show='success_message' v-html='success_message')
                button#button.btn.btn-success.btn-lg.btn-block(@click='send()' v-show='!success_message') メールを送信
</template>

<style lang="stylus">
</style>

<script>
import loader from '@/service/Loader'
import qs from 'querystring'
import Request from '@/service/Request'
export default {

  data () {
    return {
      groupId: null,
      mail: null,
      error_message: null,
      success_message: null
    }
  },
  methods: {
    send () {
      loader.show()
      let axios = Request.instance()
      this.error_message = null
      this.success_message = null
      axios.post(
        '/client/auth/request_password_reset',
        qs.stringify({
          groupId: this.groupId,
          mail: this.mail
        })
      ).then((res) => {
        this.success_message = 'パスワード再設定のメールを送信しました。<br>一時間以内にパスワードの再設定を行ってください。'
      }).catch((error) => {
        this.error_message = error.response.data.message
      }).then(() => {
        loader.hide()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// LostPassword.vue?0154e873